import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'
const ACADEMIC_PERIOD = 'academic_period'
const START_DATE = 'start_date'
const END_DATE = 'end_date'
const DESCRIPTION = 'description'
const FREE = 'free'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [ACADEMIC_PERIOD]: {
      label: `${t('school.academic-period')}`,
      name: ACADEMIC_PERIOD,
      required: true,
    },
    [START_DATE]: {
      label: `${t('common.start-date')}`,
      name: START_DATE,
      required: true,
    },
    [END_DATE]: {
      label: `${t('common.end-date')}`,
      name: END_DATE,
      required: true,
    },
    [DESCRIPTION]: {
      label: `${t('common.description')}`,
      name: DESCRIPTION,
      required: true,
    },
    [FREE]: {
      label: `${t('common.free-day')}`,
      name: FREE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [ACADEMIC_PERIOD]: null,
  [START_DATE]: null,
  [END_DATE]: null,
  [DESCRIPTION]: '',
  [FREE]: false
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [ACADEMIC_PERIOD]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('required-error-message')}`),
      })
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [START_DATE]: yup
      .date()
      .required(`${t('errors.required-error-message')}`)
      .typeError('errors.invalid-date-message'),
    [END_DATE]: yup
      .date()
      .required(`${t('errors.required-error-message')}`)
      .typeError('errors.invalid-date-message'),
    [DESCRIPTION]: yup.string().required(`${t('errors.required-error-message')}`),
  })

export default formModel
